export interface TransportDocumentsAccessQueryState {
  hasTenant: boolean;
  data: boolean | undefined;
  isSuccess: boolean;
  isPending: boolean;
  isFetching: boolean;
  isError: boolean;
}

export interface TransportDocumentsAccessState {
  enabled: boolean;
  checking: boolean;
  error: boolean;
}

// Il primo accesso resta chiuso fino alla risposta server. Dopo un successo,
// un refetch conserva la stessa pagina montata: il suo esito false/errore la
// richiude, mentre sostituirla con uno spinner riattiverebbe il lifecycle Ionic.
export function resolveTransportDocumentsAccessState(
  query: TransportDocumentsAccessQueryState,
): TransportDocumentsAccessState {
  const checking = query.hasTenant
    && !query.isSuccess
    && (query.isPending || query.isFetching);
  return {
    enabled: query.hasTenant
      && query.isSuccess
      && !query.isError
      && query.data === true,
    checking,
    error: !query.hasTenant || query.isError,
  };
}
